import React from 'react';
import List from '@material-ui/core/List';
import routesConfig from '../../../../../config/routes/routesConfig';
import VerticalCollapse from './VerticalCollapse';
import VerticalItem from './VerticalItem';
import VerticalNavGroup from './VerticalNavGroup';
import {connect, getStore} from "trim-redux";
import adminRoutes from "../../../../../config/routes/adminRoutes";
import supplierRoutes from "../../../../../config/routes/supplierRoutes";

const Navigation = (props) => {
  const {role} = props.user;
  let features = getStore('features');
  let {type} = props;
  let menu;
  if(type === "admin"){
    menu = adminRoutes
  }else if(type === "supplier"){
    menu = supplierRoutes;
  }
  else{
    menu = routesConfig;
  }
  return (
    <List style={{overflow:"auto",height:"calc(100vh - 160px)",padding:"0 10px",marginTop:10}}>
      {menu.map((item) => (
          <>
          {
              !item.roles || item.roles.indexOf(role.name) !==  -1 ?
                  !item.permission || role.permission[item.permission] ?
                      !item.feature || features[item.feature] ?
                    <React.Fragment key={item.id}>
                        {item.type === 'group' && <VerticalNavGroup item={item} level={0} role={role}/>}

                        {item.type === 'collapse' && (
                            <VerticalCollapse item={item} level={0} />
                        )}

                        {item.type === 'item' && <VerticalItem item={item} level={0} />}
                    </React.Fragment>
                : null : null : null
          }
          </>

      ))}
    </List>
  );
};
const mstp = state => ({
    user: state.user,
});
export default connect(mstp)(Navigation);
